import { Link, useMatch, useResolvedPath } from "react-router-dom"
import logo from '../../assets/logo3.png'

 
export default function Navbar() {
  return (   
     <nav className="nav"> 
       
        <Link to="/" style={{minWidth: '163px', width:'7.81vw' }}>
            <img src={logo} style={{minHeight: '4.5vh', maxHeight:'4.5vh', marginLeft: '-3vw'}} alt='' />
        </Link>

        <ul>
          <CustomLink  to="/">Home</CustomLink>    
          <CustomLink  to="/drive">V-Drive</CustomLink>   
          <CustomLink  to="/rotor">V-Rotor</CustomLink>                        
          <CustomLink  to="/about">About</CustomLink>  
          <CustomLink  to="/contact">Contact Us</CustomLink>  
        </ul>
       
    </nav>  
  )
}

function CustomLink({ to, children, ...props }) {
  const resolvedPath = useResolvedPath(to)
  const isActive = useMatch({ path: resolvedPath.pathname, end: true })

  return (
    <li className={isActive ? "active" : ""}>
      <Link to={to} {...props}>
        {children}
      </Link>
    </li>
  )
}
